import React, { Component } from 'react'
import { Card, CardHeader, CardBody, Alert, CardFooter, Button, } from 'reactstrap'
import PropTypes from 'prop-types'
import { Preview, HtmlEditor } from './'
import saveContentEdit from '../../../helpers/content/manageContent/saveContentEdit';
import { db } from '../../../config/firebaseconfig';
import TextEditor2 from '../../TextEditor/TextEditor2';
import { ImageManagerOpenButton } from './'

class PassageCard extends Component {

  state = {
    passage: '',
    error: '',
    loading: false,
    wysiwyg: false,
  }

  componentDidMount() {
    // subscribe to passage
    const { passageId } = this.props
    const { subscribeToPassage } = this
    subscribeToPassage(passageId)
  }

  subscribeToPassage = (pId) => {
    let { passageId } = this.props
    passageId = passageId || pId 
    if (passageId) {
      this.setState({loading: true})
      this.unsubscribe = db.collection('contentItemPassages').doc(passageId).onSnapshot((snapshot) => {
        this.setState({passage: snapshot.data().text, loading: false})
      }, 
      (err) => {
        this.setState({error: 'Error loading passage.', loading: false})
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { activeItemId } = this.props
    if (prevProps.activeItemId !== activeItemId) {
      const { unsubscribe, subscribeToPassage } = this
      unsubscribe()
      subscribeToPassage()
    }
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe()
  }

  toggleWysiwyg = () => this.setState({wysiwyg: !this.state.wysiwyg})

  save = (contents) => {
    const { passageId, activeItemId } = this.props
    const { subscribeToPassage } = this
    this.setState({passage: contents})
    return saveContentEdit('passage', passageId, contents, activeItemId, subscribeToPassage)
  }

  render() {
    const { 
      activeEditor, 
      openEditor, 
      closeEditor,
      editorId,
      quillText,
      handleQuillChange,
      query, } = this.props
    const { save, toggleWysiwyg } = this 
    const { error, passage, loading, wysiwyg } = this.state
    return (
      <Card>
        <CardHeader>
          <i className='icon-note icons font-1x1 mt-2'></i>  
          Passage
        </CardHeader>
        <CardBody className='card-body'>
          {activeEditor === 'passage'
            ? !wysiwyg
              ? <HtmlEditor 
                  closeEditor={closeEditor}
                  save={save}
                  contents={passage}
                  loading={loading}
                  contentType={'passage'}
                />
              : <TextEditor2
                  editorId={editorId}
                  quillText={quillText}
                  handleQuillChange={handleQuillChange}
                />
            : <Preview 
                contents={passage}
                openEditor={() => openEditor('passage', {type: 'passage', index: 0})}
                loading={loading}
              />
          }
          {error && <Alert>{error}</Alert>} 
        </CardBody>
        <CardFooter>
          <Button
            onClick={toggleWysiwyg}
          >
            {wysiwyg 
              ? 'Edit HTML'
              : 'Edit WYSIWYG'
            }
          </Button>
          {!wysiwyg &&
            <ImageManagerOpenButton query={query} />
          }
        </CardFooter>
      </Card>
    )
  }
}

PassageCard.propTypes = {
  activeItemId: PropTypes.string.isRequired,
  activeEditor: PropTypes.string.isRequired,
  passage: PropTypes.string.isRequired,
  openEditor: PropTypes.func.isRequired,
  closeEditor: PropTypes.func.isRequired,
  passageId: PropTypes.string,
  editorId: PropTypes.object.isRequired,
  quillText: PropTypes.string,
  handleQuillChange: PropTypes.func.isRequired,
}

export default PassageCard


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/PassageCard.js